// Shared formatting for the Tax Center screens.

/** UTC 'YYYY-MM-DD HH:MM:SS' (or ISO) → local date-time string. */
export function when(value) {
  if (!value) return '';
  const s = String(value);
  const d = new Date(s.includes('T') ? s : `${s.replace(' ', 'T')}Z`);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleString();
}
